import { configureStore } from "@reduxjs/toolkit";
import userReducer from './usersSlice'
import websitesReducer from './websitesSlice'
import websiteImagesReducer from './websiteImagesSlice'
import shopifyShopReducer from './shopifyShopSlice'
import shopifyProductReducer from './shopifyProductsSlice'
import shopifyMediaReducer from './shopifyMediaSlice'
import companyReducer from './companySlice'
import customProductReducer from './customProductSlice'
import jobReducer from './jobSlice'
import adminReducer from './adminSlice'

export const store = configureStore({
    reducer: {
        users: userReducer,
        websites: websitesReducer,
        websiteImages: websiteImagesReducer,
        shopifyShops: shopifyShopReducer,
        shopifyProducts: shopifyProductReducer,
        shopifyMedia: shopifyMediaReducer,
        companies: companyReducer,
        customProducts: customProductReducer,
        jobs: jobReducer,
        admin: adminReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }),
})


export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
